module.exports = __webpack_public_path__ + "static/media/h5备份 2.4ed8d491.jpg";